import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchVisitConfigLogs = async ({ page, trialId, patientId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("page", page);
  params.append("trial", trialId);
  params.append("patient", patientId);

  const response = await axios.get(
    `${__API_URL__}/api/photos/visit_config_logs/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetVisitConfigLogs = ({ page = 1, trialId, patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_config_logs", page, trialId, patientId],
    queryFn: () => fetchVisitConfigLogs({ page, trialId, patientId }),
    enabled: enabled && Boolean(trialId && patientId),
    keepPreviousData: true,
  });
};

export default useGetVisitConfigLogs;
